import * as THREE from 'three';

/**
 * Classify cupboard / lar mesh roles without Blender renaming.
 * - top: lids / tops by name
 * - handle: tiny meshes vs median volume (knobs, pulls)
 * - body: everything else
 */
export function classifyFurnitureRole( mesh, peers = [] ) {

  const name = String( mesh?.name || '' ).toLowerCase();

  if (
    name.includes( 'top' )
    || name === 'lartop'
    || name.includes( 'cupboardtop' )
  ) {

    return 'top';

  }

  if ( name.includes( 'handle' ) || name.includes( 'knob' ) || name.includes( 'ручка' ) ) {

    return 'handle';

  }

  if ( !peers.length ) return 'body';

  const vols = peers.map( meshWorldVolume ).filter(( v ) => v > 1e-8 ).sort(( a, b ) => a - b );
  if ( !vols.length ) return 'body';

  const median = vols[ Math.floor( vols.length / 2 ) ];
  const v = meshWorldVolume( mesh );

  // Hardware is typically << 8% of the median body volume
  if ( median > 0 && v > 0 && v < median * 0.08 ) {

    return 'handle';

  }

  return 'body';

}

export function meshWorldVolume( mesh ) {

  const box = new THREE.Box3().setFromObject( mesh );
  const size = new THREE.Vector3();
  box.getSize( size );

  return Math.max( 0, size.x ) * Math.max( 0, size.y ) * Math.max( 0, size.z );

}

/**
 * Clone a constructor PBR material into a furniture-role variant.
 * Shares texture maps with the source (dispose via sharedMaps flag).
 */
export function variantFurnitureMaterial( source, role = 'body' ) {

  if ( !source ) return source;
  if ( role === 'body' ) return source;

  const mat = source.clone();
  mat.userData = {

    ...( source.userData || {} ),
    isConstructorMaterial: true,
    sharedMaps: true,
    furnitureRole: role,

  };

  // Keep map refs (clone() already copies refs)
  if ( role === 'handle' ) {

    mat.metalness = 0.82;
    mat.roughness = 0.22;
    mat.clearcoat = 0.55;
    mat.clearcoatRoughness = 0.18;
    mat.envMapIntensity = Math.min( 1.4, ( source.envMapIntensity || 0.5 ) + 0.35 );
    if ( mat.normalScale ) mat.normalScale.set( 0.35, 0.35 );

  } else if ( role === 'top' ) {

    mat.roughness = Math.max( 0.22, ( source.roughness || 0.4 ) - 0.1 );
    mat.clearcoat = Math.max( 0.35, source.clearcoat || 0.25 );
    mat.clearcoatRoughness = 0.22;
    mat.envMapIntensity = Math.min( 1.2, ( source.envMapIntensity || 0.5 ) + 0.15 );

  }

  mat.needsUpdate = true;

  return mat;

}
